import type { MilestoneMap1 } from '../types/MilestoneMap1';
import type { ZoneOptions } from './zone';
import { getIntervalsForMilestoneMap } from './getIntervalsForMilestoneMap';

export function calculateIntervalRange(
  forIntervalEnding: string,
  milestoneMap: MilestoneMap1,
  intervalOverride?: MilestoneMap1['interval'],
  options: ZoneOptions = {},
): [Date, Date] {
  // Get all intervals for the map, using intervalOverride if provided for zoom functionality
  const intervals = getIntervalsForMilestoneMap(milestoneMap, intervalOverride, options);
  // Find the interval that ends at forIntervalEnding (full ISO match for precision)
  const found = intervals.find((interval) => interval.end.toISOString() === forIntervalEnding);
  if (!found) {
    // fallback: return the last interval
    return [intervals[intervals.length - 1].start, intervals[intervals.length - 1].end];
  }
  return [found.start, found.end];
}
